import { gql } from 'graphql-request';

import {
  UserCompetencyCompetencyID,
  UserCompetencyCompetencyName,
  UserCompetencyDefaultAt,
  UserCompetencyID,
  UserCompetencyLabel,
  UserCompetencyNanoID,
  UserCompetencyPresenceType,
  UserCompetencyUUID,
  UserCompetencyValue
} from '../userCompetenciesTypes';

interface FetchCacheUserCompetencyCompetency {
  id: UserCompetencyCompetencyID;
  name: UserCompetencyCompetencyName;
}

export interface FetchCacheUserCompetenciesQueryResponse {
  id: UserCompetencyID;
  uuid: UserCompetencyUUID;
  nanoId: UserCompetencyNanoID;
  presenceType: UserCompetencyPresenceType;
  value: UserCompetencyValue;
  label: UserCompetencyLabel;
  defaultAt: UserCompetencyDefaultAt;
  competency: FetchCacheUserCompetencyCompetency;
}

export const FETCH_CACHE_USER_COMPETENCIES_QUERY = gql`
  query CacheUserCompetencies(
    $filters: UserCompetenciesFilters
    $sort: [UserCompetenciesSortEnum!]
    $limit: Int
    $offset: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    userCompetencies(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        id
        uuid
        nanoId
        presenceType
        value
        label
        defaultAt
        competency {
          id
          name
        }
      }
      paginationInfo {
        nextPage
        totalCount
      }
      sql
    }
  }
`;
